<template>
  <Dialog :visible="visible" class="share-dialog layout-content" :modal="true" 
              :closable="false" :dismissableMask="true" :style="{width: '90vw'}" :draggable="false"
              @update:visible="updateVisible" >

    <div class="irinox-form" >
      <div class="search-bar" style="float: right">
        <i class="pi pi-search" />
        <InputText v-model="filters['global'].value" :placeholder="$t('admin.appliances.search_short')" style="width:70px"/>
        <i class="pi pi-times" @click="function() {filters['global'].value=null}"/>
      </div>
      <div class="p-formgroup-inline p-ai-center">
        <div class="p-field">
          <Dropdown id="modelNumber" v-model="filters['modelNumber'].value" :options="modelNumbers" optionLabel="name" optionValue="code"
            :placeholder="$t('admin.appliances.filter_model_ph')" />
        </div>
        <div class="p-field">
          <ToggleButton v-model="statusButton" :onLabel="$t('admin.appliances.filter_online')" :offLabel="$t('admin.appliances.filter_online')"  />      
        </div>
      </div>
    </div>
    
    <DataTable :value="appliances" v-model:selection="selectedAppliances" stripedRows 
      v-model:filters="filters" responsiveLayout="stack" dataKey="serialNumber" 
      breakpoint="900px" sortField="serialNumber" :sortOrder="1"
      :paginator="true" paginatorPosition="bottom" paginatorTemplate="CurrentPageReport FirstPageLink PrevPageLink PageLinks NextPageLink LastPageLink" 
      v-model:first="table.first" :rows="table.rows" :totalRecords="table.totalRecords" :lazy="true"
      @update:first="reloadAppliances" 
      :currentPageReportTemplate="'{totalRecords} ' + $t('factory.appliances.counter')"
       >
      <template #empty>
          {{$t('admin.appliances.empty_list')}}
      </template>
      <template #loading>
          {{$t('admin.appliances.loading_list')}}
      </template>
      <Column field="serialNumber" :header="$t('admin.appliances.col_serialnumber')" ></Column>
      <Column field="modelNumber" filterField="modelNumber" :header="$t('admin.appliances.col_model')" >
        <template #body="slotProps">
          <div>
            {{$functions.fixModelName(slotProps.data.modelNumber)}} 
            <img v-if="slotProps.data.online" src="assets/irinox/icons/status_online_small.svg" class="p-pl-1" :alt="$t('common.online')" />
            <img v-else src="assets/irinox/icons/status_offline_small.svg" class="p-pl-1" :alt="$t('common.offline')" />
          </div>
        </template>
      </Column>
      <Column selectionMode="multiple" style="width:70px"></Column>
    </DataTable>

    <ScrollTop target="parent" />
    
    <template #footer>
      <Button :label="$t('admin.appliances.share_dialog_cancel_button')" @click="leftButtonClick" class="p-button-secondary" />
      <Button :label="$t('admin.appliances.share_dialog_ok_button')" @click="rightButtonClick"/>
    </template>
  </Dialog>
</template>

<script>
import ApplianceService from '../service/ApplianceService';
import {FilterMatchMode} from 'primevue/api';

export default {
    emits: ['update:visible','click:left-button','click:right-button'],
    props: {
      visible: Boolean,
      email: String,
      leftB: {
        type: String,
        required: false
      },
      rightB: {
        type: String,
        required: false
      },
      preselectedAppliances: Array
    },
    data() {
        return {
          filters: {
              'global': {value: null, matchMode: FilterMatchMode.CONTAINS},
              'modelNumber': {value: null, matchMode: FilterMatchMode.EQUALS},
              'online': {value: null, matchMode: FilterMatchMode.EQUALS}
          },
          appliances: [],
          selectedAppliances: [],
          modelNumbers: [],
          statusButton: false,
          table: {
            rows: 50,
            totalRecords: 0,
            first: 0
          },
          freeSearchTimer: null,
        };
    },
    computed: {
      personaltoken: function() {
          return this.$store.getters['userdata/personaltoken'];
      },
    },
    watch: {
      preselectedAppliances: 'preselectAppliances',
      statusButton: 'statusButtonToggle',
      "filters.global.value": "freeSearch",
      "filters.online.value": "changeFilters",
      "filters.modelNumber.value": "changeFilters",
    },
    created() {
      this.applianceService = new ApplianceService();
    },
    mounted() {
      this.reloadFilters();
      this.reloadAppliances();
    },
    methods: {
      freeSearch() {
        clearTimeout(this.freeSearchTimer);
        this.freeSearchTimer = setTimeout(() => {
          this.changeFilters();
        }, 500 );
      },
      reloadFilters() {
        let mns = [];
        let emptyData = { 
          code: null,
          name: this.$t('factory.appliances.filter_remove') 
        };

        this.applianceService.getModelsForFilter(this.personaltoken, this.email)
          .then((models) => {
            for(const model of models) {
              mns.push({ 
                code: model.gamma + "|||" + model.modelName, 
                name: this.$functions.fixModelName(model.gamma + " " + model.modelName) 
              });
            }
            this.modelNumbers = this.$functions.uniqByKeepFirst(mns, item => item.code).sort((a,b) => this.$functions.compareStrings(a,b,'name'));
          })
          .catch(error => {
            console.error("FILTER MODELS ERROR", error);
          })
          .finally(() => {
            this.modelNumbers.unshift(emptyData);
          });

      },
      changeFilters() {
        this.table.first = 0;
        this.reloadAppliances();
      },
      reloadAppliances() {
        this.applianceService.getFactoryAppliancesFilter(this.personaltoken, this.email, this.filters, this.table)
          .then((appliances) => {
            this.table.totalRecords = appliances.count;
            this.appliances = appliances.items;
          })
          .catch(error => {
            console.error("EXCEPTION "+error);
            this.table.totalRecords = 0;
            this.appliances = [];
          });
      },
      preselectAppliances() {
        this.selectedAppliances = this.preselectedAppliances;
      },
      updateVisible(value) {
        this.$emit("update:visible", value);
      },
      leftButtonClick() {
        this.preselectAppliances();
        this.$emit("click:left-button");
      },
      rightButtonClick() {
        this.$emit("click:right-button", this.selectedAppliances);
      },
      statusButtonToggle() {
        if(this.statusButton) {
          this.filters['online'].value = true;
        } else {
          this.filters['online'].value = null;
        }
      }
    }
}
</script>

<style>

/* .p-dialog.share-dialog {
  box-shadow: none;
  height: 100vh;
} */

.p-dialog.share-dialog .p-dialog-content {
  padding: 0 0 2rem 0;
  height: 90vh;
}
.p-dialog.share-dialog .p-dialog-content .irinox-form {
  padding: 0 1.5rem 0 1.5rem;
}
.p-dialog.share-dialog .p-dialog-content .irinox-form .p-dropdown {
  width: 200px;
}

.share-dialog.layout-content {
  flex: none;
  padding: 0;
}

</style>